<template lang="html">
  <div class="header">
    <div class="header-box">
      <div class="header-left">
        <span @click="switchTag('all')" :class="{ active: 'all' === categoryId }">首页</span>
        <span v-for="item in tags" @click="switchTag(item.nid)" :class="{ active: item.nid === categoryId }" :key="item.nid">{{item.title}}</span>
      </div>
      <div class="header-right">
        <button @click="create">
          发帖
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from '../utils/request'
import { createNamespacedHelpers } from 'vuex'
import { set } from '../utils/token'
const { mapActions } = createNamespacedHelpers('communication')
export default {
  data () {
    return {
      tags: [],
      categoryId: 'all'
    }
  },
  methods: {
    ...mapActions({
      updateTag: 'updateTag'
    }),
    create () {
      this.$router.push('/exerland/create')
    },
    switchTag (tag) {
      this.$router.push('/exerland/communication')
      this.updateTag(tag)
      this.categoryId = tag
      set('categoryId', tag)
    },
    getTags () {
      const promise = get({
        url: '/bbs/category'
      })
      promise.then(res => {
        const { status, data } = res
        if (Object.is(status, 200)) {
          this.tags = data
        }
      })
    }
  },
  mounted () {
    this.getTags()
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/font/iconfont.css';
.header {
  margin: 0 0 15px 0;
  height: 50px;
  line-height: 50px;
  border-radius: 2px;
  background-color: #fff;
  box-shadow: 0 1px 2px 0 rgba(0,0,0,.05);
  .header-box {
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .header-left {
      height: 100%;
      span {
        padding:0 10px;
        cursor: pointer;
        display: inline-block;
        -webkit-tap-highlight-color:transparent;
      }
      .active {
        color: '#5FB878';
        position: relative;
        display: inline-block;
        &::after {
          position: absolute;
          content: '';
          width: calc(100% - 20px);
          height: 4px;
          bottom: 0;
          left: 10px;
          background: #18CC9F;
        }
      }
    }
    .header-right {
      display: flex;
      align-items: center;
      .icon {
        font-size: 21px;
        margin-right: 39px;
      }
      button {
        display: inline-block;
        height: 38px;
        line-height: 38px;
        padding: 0 18px;
        background-color: #009688;
        color: #fff;
        white-space: nowrap;
        text-align: center;
        font-size: 14px;
        border: none;
        border-radius: 2px;
        cursor: pointer;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .header {
    height: auto;
    .header-box {
      justify-content: center;
      flex-direction: column;
      .header-left {
        max-width: 100%;
        overflow-x: scroll;
        white-space: nowrap;
        &::-webkit-scrollbar {
          display: none;
        }
      }
      .header-right {
        // margin-bottom: 15px;
        position: fixed;
        right: 20px;
        bottom: 69px;
        width:61px;
        height:61px;
        box-sizing: border-box;
        background:rgba(0,150,136,1);
        box-shadow:0px 2px 16px 0px rgba(0,0,0,0.16);
        border-radius: 50%;
        z-index: 99999;
        .icon {
          display: none;
        }
        button {
          width: 61px;
          height: 61px;
          border-radius: 50%;
          padding: 0;
        }
      }
    }
  }
}
@media screen and (min-width: 768px) {
  .header {
    .header-box {
      width: 750px;
    }
  }
}
@media screen and (min-width: 992px) {
  .header {
    .header-box {
      width: 970px;
    }
  }
}
@media screen and (min-width: 1200px) {
  .header {
    .header-box {
      width: 1170px;
    }
  }
}
</style>
